import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorGold = createSvgIcon(
  <circle cx="10" cy="10" fill="#C7A325" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorGold',
);
